'use client'

import { type ReactNode } from 'react'

import MotionProvider from './MotionProvider'

type DeferredMotionProviderProps = {
  children: ReactNode
}

/**
 * Motion shell for the locale layout.
 *
 * Deferred mount until first gesture remounted the whole app tree
 * (MotionProvider wrapping children). Always wrap so chrome stays stable.
 */
export default function DeferredMotionProvider({
  children
}: DeferredMotionProviderProps) {
  return <MotionProvider>{children}</MotionProvider>
}
